import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';

import { Store, select } from '@ngrx/store';
import { CompanyDto, FunctionDto } from '@cradua/data';
import { Observable } from 'rxjs/internal/Observable';
import { routeAnimations, ROUTE_ANIMATIONS_ELEMENTS } from 'libs/core/src/lib/animations';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';

@Component({
  selector: 'cradua-function-container',
  templateUrl: './function-container.component.html',
  styleUrls: ['./function-container.component.scss']
})
export class FunctionContainerComponent implements OnInit {
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  companies$: Observable<CompanyDto[]>;
  functions$: Observable<FunctionDto[]>;
  loading: boolean;
  isCompanyLoading$: Observable<boolean>;
  isLoading$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.isCompanyLoading$ = this.gatwayFacade.isLoadingGateway("Company");
    this.companies$ = this.gatwayFacade.loadGateway("Company");
    this.isLoading$ = this.gatwayFacade.isLoadingGateway("Function");
    this.functions$ = this.gatwayFacade.loadGateway("Function");
    this.functions$.subscribe(data => {
      console.log("data: cont.",data);
    })
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteFunction(deletedValue: any) {
    this.gatwayFacade.remove("Function", deletedValue);
    // this.store.dispatch(FunctionStoreActions.removeFunction({ids: deletedValue}));
    this.notificationService.success('Deleted Successfully');
  }

// this method control both the create and update
  onSubmitFunction(formValue: any) {
    console.log("form value: ", formValue);
    formValue.Functions = formValue.Functions.reverse();
    event.preventDefault();
    const pullData = formValue.Functions;
    //const newPullData = formValue.Functiones;

// declare two empty array to hold update and create data
  let allUpdates = [] ;
  let addAllFunction = [];

// loop through the form data to check for update and create
  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id) {
      allUpdates.push(pullData[i]);
    } else {
      console.log("without id: ", pullData);
      addAllFunction.push(pullData[i]);
    }
  }

// check if the addAllFunction array is not empty, then dispatch the data to the store
   if(addAllFunction.length !== 0) {
    this.gatwayFacade.add('Function', addAllFunction);
    // this.store.dispatch(FunctionStoreActions.addFunction({newFunction: addAllFunction}));
   }

// dispatch update data to the store
    this.gatwayFacade.update('Function', allUpdates, ['id']);
    // this.store.dispatch(FunctionStoreActions.updateFunction({updateFunction: allUpdates}));
    this.notificationService.success('Saved Successfully');
  }
}
